module.exports = __webpack_public_path__ + "static/media/MyriadPro-Bold.1d3bb1b7.svg";